import { render, staticRenderFns } from "./AdditionalParticipantList.vue?vue&type=template&id=3f274668&"
import script from "./AdditionalParticipantList.vue?vue&type=script&lang=js&"
export * from "./AdditionalParticipantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports